// src/algorithms/ordered/index.ts
import type { DitherAlgorithm } from '../../core/types';

export const ORDERED_ALGORITHMS: DitherAlgorithm[] = [
  { id: 'bayer',       label: 'Bayer',       kind: 'ordered',  runner: 'gpu', tileRange: { min: 1, max: 4 } },
  { id: 'blue-noise',  label: 'Blue Noise',  kind: 'ordered',  runner: 'gpu', tileRange: { min: 1, max: 16 } },
  { id: 'white-noise', label: 'White Noise', kind: 'ordered',  runner: 'gpu', tileRange: { min: 1, max: 16 } },
];
